/**
 * WESTERN_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Western / Americana music.
 * Traits:
 * - Galloping / Train Beat Rhythm (High Rhythmic Lock)
 * - Pentatonic / Major Tonality (High Consonance)
 * - Mid-Range Focus (Guitar, Violin, Trumpet)
 * - Moderate Pacing
 */

import { BASE_ARCHETYPE } from './BaseArchetype.js';

export const WESTERN_ARCHETYPE = {
    ...BASE_ARCHETYPE,

    // Voice Distribution: Mid-High Focus.
    // Acoustic Guitar, Fiddle, Trumpet. Less emphasis on Cinematic Sub-Bass.
    voiceDistribution: {
        ...BASE_ARCHETYPE.voiceDistribution,
        low: 0.25,
        mid: 0.45,
        high: 0.30,
        tolerance: 0.15,
        tuttiThreshold: 0.9
    },

    // Dynamic Range: Moderate.
    // Consistent energy, not extreme swells.
    dynamicRange: {
        ...BASE_ARCHETYPE.dynamicRange,
        minVariance: 0.10,
        targetVariance: 0.20
    },

    // Rhythmic Lock: Critical.
    // The "Gallop" needs tight synchronization.
    rhythmicLock: {
        ...BASE_ARCHETYPE.rhythmicLock,
        target: 0.90,
        weight: 0.3
    }
};
